import script from "./SimpleText.vue?vue&type=script&lang=js"
export * from "./SimpleText.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__